import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../common/services/api/api.service';
import { environment } from 'src/environments/environment';
import { GETINCIDENTDATAUPLOADSTATUS, GETINCIDENTDATAUPLOADCLUSTERDETAILS } from '../common/constants/labels';

@Injectable({
  providedIn: 'root'
})
export class IncidentUploadStatusService {
  getIncidentDataUploadStatusUrl = environment.APISETTINGS + GETINCIDENTDATAUPLOADSTATUS;
  getIncidentDataUploadClusterDetailsUrl = environment.APISETTINGS + GETINCIDENTDATAUPLOADCLUSTERDETAILS;
  constructor(private service: ApiService) { }

  public getIncidentDataUploadStatusData(): Observable<any> {
    return this.service.get(this.getIncidentDataUploadStatusUrl);
  }

  public getIncidentDataUploadClusterData(): Observable<any> {
    return this.service.get(this.getIncidentDataUploadClusterDetailsUrl);
  }

}
